let linkConfig = {
  download: {
    ios: {
      kol: "https://apps.apple.com/cn/app/eet-global/id6770900088",
    },
    androidUrl: {
      kol: "https://downloads.appxzkol.com/source/material/EET_KOL.apk",
      kol_backup1: "https://downloads.kolappxz.com/source/material/EET_KOL.apk",
    },
  },
};

export { linkConfig };
